import { useFormState } from "react-hook-form";

import { Loader } from "@/atoms";

type FormLoadingProps = {
  fullScreen?: boolean;
};

export default function FormLoading({
  fullScreen,
}: FormLoadingProps): React.ReactElement | null {
  const { isSubmitting } = useFormState();

  if (!isSubmitting) return null;

  return <Loader fullScreen={fullScreen} visible />;
}
